import { IfFeatureEnabled } from "../../../IfFeatureEnabled";
import { useState } from "react";
import { TemplateDialog } from "./TemplateDialog";
import { useLocalUser } from "../data";
import { SplitButton } from "primereact/splitbutton";
import { ParsedTemplate, TemplateUseCase, useTemplates } from "./data";

export const TemplateButton = ({
  useCase,
  onOverrideTemplateVersion,
  suffix,
}: {
  useCase: TemplateUseCase;
  onOverrideTemplateVersion: (template: ParsedTemplate | undefined) => void;
  suffix?: string;
}) => {
  const me = useLocalUser();
  const templates = useTemplates(me, useCase);
  const [visible, setVisible] = useState(false);

  return (
    <IfFeatureEnabled feature="template-management" user={me}>
      <SplitButton
        label={suffix ? `Manage ${suffix}` : "Manage"}
        onClick={() => setVisible(true)}
        tooltip="Manage template versions"
        tooltipOptions={{ showDelay: 500 }}
        raised
        text
        model={[
          {
            label: "Use live version",
            command: () => onOverrideTemplateVersion(undefined),
          },
        ].concat(
          templates.data?.map((t) => ({
            label: `Test ${t.template_name}`,
            command: () => onOverrideTemplateVersion(t),
          })) ?? []
        )}
      />
      <TemplateDialog
        visible={visible}
        onHide={() => setVisible(false)}
        useCase={useCase}
      />
    </IfFeatureEnabled>
  );
};
